module.exports = __webpack_public_path__ + "img/38_45.e14cf0f8.png";